export const apiUrl = "https://apicsd.nelumbo.com.co/api/" //DEV
